// Keep diagnostic locations useful without collecting URLs, queries or map coordinates.
export function scriptLocation(value) {
  if (typeof value !== "string") return "";
  const match = value.match(/(?:^|\/)([\w.-]+\.m?js)((?:[?#][^\s)]*)?(?::\d+:\d+)?)(?:[\s)]|$)/);
  if (!match) return "";
  const position = match[2].match(/:(\d+):(\d+)$/);
  return `${match[1]}${position ? `:${position[1]}:${position[2]}` : ""}`;
}

export function diagnosticBuild() {
  const script = document.querySelector(
    'script[src*="/static/dist/app.js"], script[src*="/static/dist/site.js"], script[src*="/static/dist/three-d.js"]'
  );
  if (!script) return "";
  const url = new URL(script.src, location.origin);
  const version = url.searchParams.get("v") || "";
  return /^[a-f0-9]{8,64}$/.test(version) ? `${scriptLocation(url.pathname)}:${version}` : "";
}

export function browserErrorDetails(error, fallback = "") {
  const type = typeof error?.name === "string" ? error.name : error == null ? "UnknownError" : typeof error;
  // Summaries use fixed categories: arbitrary rejection strings can contain private data.
  const message = typeof error === "string" ? error : typeof error?.message === "string" ? error.message : fallback;
  let category = "exception";
  if (/failed to fetch|load failed|network|fetch.*failed/i.test(message)) category = "network";
  else if (/script error/i.test(message)) category = "cross_origin_script";
  else if (/cannot read|undefined|null is not|not a function/i.test(message)) category = "invalid_value";
  else if (/permission|denied|notallowed/i.test(message)) category = "permission";
  else if (/timeout|timed out/i.test(message)) category = "timeout";
  else if (error?.name === "SyntaxError") category = "syntax";
  const frames = typeof error?.stack === "string"
    ? error.stack.split("\n").map(scriptLocation).filter(Boolean).slice(0, 5).join(" <- ") : "";
  return { errorType: type.slice(0, 40), category, frames };
}
